import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sv-page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", { class: "sv-page-header" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "sv-page-header__eyebrow" }, "Configuração operacional"),
    /*#__PURE__*/_createElementVNode("h1", null, "Editar operação"),
    /*#__PURE__*/_createElementVNode("p", null, "Atualize os dados da operação e configure a integração via SFTP.")
  ])
], -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-xxl-12" }
const _hoisted_5 = { class: "col-xxl-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormUpdateOperation = _resolveComponent("FormUpdateOperation")!
  const _component_UpdateConfigurationsSftp = _resolveComponent("UpdateConfigurationsSftp")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_FormUpdateOperation)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_UpdateConfigurationsSftp)
      ])
    ])
  ]))
}